import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { UploadFilesService } from '../upload-files.service';
import {
  loadDocumentTypes,
  loadDocumentTypesFailure,
  loadDocumentTypesSuccess,
} from './upload-files.actions';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { documentTypesLoaded } from '../../../liabilities/state/liabilities.actions';

@Injectable()
export class UploadFilesEffects {
  private readonly action$ = inject(Actions);
  private readonly service = inject(UploadFilesService);

  public readonly loadDocumentTypes$ = createEffect(() =>
    this.action$.pipe(
      ofType(loadDocumentTypes),
      switchMap(() =>
        this.service.getDocumentTypes().pipe(
          map((documentTypes) => [
            loadDocumentTypesSuccess({
              documentTypes,
              loading: false,
            }),
            documentTypesLoaded(),
          ]),
          catchError((error) =>
            of(
              loadDocumentTypesFailure({ error, loading: false }),
              documentTypesLoaded()
            )
          )
        )
      ),
      switchMap((actions) =>
        Array.isArray(actions) ? of(...actions) : of(actions)
      )
    )
  );
}
